/**
 * Типы входящих сообщений от фрейма оплаты
 */
import { WEB_SDK_SOURCE } from '../../constants';
import { CommonFrameApplePayMessage, FrameApplePayOutgoingMessageType, FrameApplePaySuccessMessage } from '../../types';

export function createFrameApplePaySuccessMessage(
    payment: ApplePayJS.ApplePayPayment,
    merchantId: string,
): FrameApplePaySuccessMessage {
    return {
        source: WEB_SDK_SOURCE,
        type: FrameApplePayOutgoingMessageType.success,
        data: {
            // eslint-disable-next-line camelcase
            apple_token: JSON.stringify(payment.token.paymentData),
            // eslint-disable-next-line camelcase
            apple_pay_merchant_id: merchantId,
        },
    };
}

export interface FrameApplePayFailureMessage extends CommonFrameApplePayMessage {
    type: FrameApplePayOutgoingMessageType.failure;
}

export function createFrameApplePayFailureMessage(): FrameApplePayFailureMessage {
    return {
        source: WEB_SDK_SOURCE,
        type: FrameApplePayOutgoingMessageType.failure,
    };
}

export interface FrameApplePayCancelMessage extends CommonFrameApplePayMessage {
    type: FrameApplePayOutgoingMessageType.cancel;
}

export function createFrameApplePayCancelMessage(): FrameApplePayCancelMessage {
    return {
        source: WEB_SDK_SOURCE,
        type: FrameApplePayOutgoingMessageType.cancel,
    };
}

export type FrameApplePayOutgoingMessage =
    | FrameApplePaySuccessMessage
    | FrameApplePayFailureMessage
    | FrameApplePayCancelMessage;
